import { JobPostingModel } from '@/ApiTypes';
import { BuildType } from '@/services/ApiService.ts';
import { UserJobModel } from '@/apiTypes/UserTypes.ts';

export interface QueryJobFilters {
    onets?: string[];
    employment_type?: number[];
    contract_type?: number[];
    remote_type?: number[];
    is_internship?: boolean;
    state_name?: string[];
    showFavorites?: boolean;
    searchTerm?: string;
    minSalary?: number;
    maxSalary?: number;
}

export interface QueryJobParams {
    filters: QueryJobFilters;
    limit: number;
    page: number;
    skip?: boolean;
}

type JobsResponse = {
    rows: JobPostingModel[];
    count: number;
};

type UserJobsResponse = {
    rows: UserJobModel[];
    count: number;
};

export const jobApiEndpoints = (build: BuildType) => ({
    jobs: build.query<JobsResponse, QueryJobParams>({
        query: params => ({
            url: 'jobs/query',
            method: 'POST',
            body: params,
        }),
        transformResponse: (response: JobsResponse) => response,
        providesTags: ['Jobs'],
    }),
    userJobs: build.query<UserJobsResponse, QueryJobParams>({
        query: params => ({
            url: 'user-jobs/query',
            method: 'POST',
            body: params,
        }),
        transformResponse: (response: UserJobsResponse) => response,
    }),
    jobByExternalSourceValue: build.query<JobPostingModel, string>({
        query: id => `jobs/${id}`,
        transformResponse: (response: JobPostingModel) => response,
    }),
    favoriteJob: build.mutation<void, JobPostingModel>({
        query: job => ({
            url: `user-jobs/favorite`,
            method: 'POST',
            body: {
                jobDetails: {
                    ...job,
                    city: job.location?.city,
                    state: job.location?.state,
                },
            },
        }),
        invalidatesTags: ['Favorites', 'Jobs'],
    }),
    favoriteUserJob: build.mutation<void, UserJobModel>({
        query: job => ({
            url: `user-jobs/favorite`,
            method: 'POST',
            body: { jobDetails: job },
        }),
        invalidatesTags: ['Favorites', 'Jobs'],
    }),
});
